import { useTranslation } from 'react-i18next';
import UploadWidget from '@quicktools/shared-components/components/common/Widgets/UploadWidget';
import applyMask from '@quicktools/shared-components/utils/applyMask';
import ProcessingWidget from '@quicktools/shared-components/components/common/Widgets/ProcessingWidget';
import { useCallback, useContext, useState } from 'react';

import { AppContext } from '../../store';
import { resizeImage, handleRemoveBackground } from '../../utils/common';
import { appConfig } from '../../configs';
import { ProcessStep } from '../../types';
import sendWindowMessage from '../../utils/windowMessage';

import useStyles from './styles';

function Upload() {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(false);
  const classes = useStyles();
  const { state, dispatch } = useContext(AppContext);

  const handleUpload = async (files: File[]) => {
    if (!files?.length) {
      return;
    }

    const uploadedFile = Array.from(files)[0];
    if (!appConfig.allowedUploadTypes.includes(uploadedFile.type)) {
      dispatch({ errorMessage: t('widget.wrongFileType') });
      return;
    }

    setLoading(true);

    try {
      const resizedImage = await resizeImage(URL.createObjectURL(uploadedFile));
      const maskUrl = await handleRemoveBackground(resizedImage);
      const resultImageUrl = await applyMask(resizedImage, maskUrl);

      dispatch({ processStep: ProcessStep.Download, uploadData: resultImageUrl });
    } catch (e) {
      dispatch({ errorMessage: t('widget.serverError'), processStep: ProcessStep.Upload });
    }

    // send post message to parent window
    // this message is used by parent apps for analytics
    sendWindowMessage({
      type: 'button-click',
      message: 'upload',
    });
  };

  const handleBtnDownloadClick = useCallback(() => {
    // send post message to parent window
    // this message is used by parent apps for analytics
    sendWindowMessage({
      type: 'button-click',
      message: 'click',
    });
  }, []);

  return (
    <ProcessingWidget loading={isLoading} text={t('widget.processingText')}>
      <UploadWidget
        accept={`${appConfig.allowedUploadTypes}`}
        imgContainerClassName={classes.imageContainer}
        heading={t('widget.heading')}
        retryBtnText={t('widget.retryButton')}
        errorMessage={state.errorMessage}
        imgAlt={t('widget.imgAlt')}
        imgSrc={'https://cdn140.picsart.com/qt-bg-remover-hero-banner.webp'}
        handleUpload={handleUpload}
        uploadBtnText={t('widget.uploadButton')}
        onClickBtn={handleBtnDownloadClick}
      />
    </ProcessingWidget>
  );
}

export default Upload;
